import { baseUrl } from "util/APIBaseUrl";
import postRequest from "util/APIHelperPost";

export const exchangeHandoffCode = async (code: string) => {
  return await postRequest(`${baseUrl}/auth/exchange`, JSON.stringify({ code }));
};
